import * as React from "react";
import {Component } from "react";

import "./footer.scss";

import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {UiState} from "../../../core/ui-state";
import {observer} from "mobx-react";
import {ScaleBar} from "../../../core/components/scalebar/scalebar";
import {Attribution} from "../../../core/components/attribution/attribution";
import {Coordinate} from "../../../core/components/coordinate/coordinate";
import {AppConfiguration} from "../../../core/config/app-configuration";
import MediaQuery from "react-responsive";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";


export interface FooterProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
    mapViewerConfig: MapViewerConfiguration;
}

@observer
export class Footer extends Component<FooterProps, any> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    render(): JSX.Element | null {
        const {appConfig, appStore, mapStore, uiStore, mapViewerConfig} = this.props;
        return(
            <div className={"geo-app-footer"}>
                <div className={"geo-scalebar-coordinate"}>
                    <ScaleBar
                        config={appConfig.scaleBar}
                        view={mapStore.view}
                        uiStore={uiStore} />
                    <MediaQuery minWidth={(mapViewerConfig.breakpoints.md + 1)}>
                        <Coordinate
                            view={mapStore.view}
                            uiStore={uiStore} />

                    </MediaQuery>
                </div>
                <Attribution
                    appStore={appStore}
                    config={appConfig.attribution}
                    view={mapStore.view}
                    uiStore={uiStore} />
            </div>
        );
    }
}
